var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',{attrs:{"label":"label","value":_vm.selected,"options":_vm.options,"searchable":false,"show-labels":false,"disabled":!_vm.canRefine},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }